import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SystemApiClient } from "../clients/system-api/SystemApiClientp";
import { PaginationArgs, ServiceDataPaginationDataAdministrationResult, ServiceData, AdministrationResultStatus, ServiceDataAdministrationResult } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
  })
  export class ServiceService {
    constructor (private systemApiClient: SystemApiClient) { }

    retrieveAllServices(body: PaginationArgs | undefined): Observable<ServiceDataPaginationDataAdministrationResult>{
        return this.systemApiClient.retrieveAllServices(body);
    }

    addService(body: ServiceData | undefined): Observable<AdministrationResultStatus>    {
        return this.systemApiClient.addService(body);
    }

    editService(body: ServiceData | undefined): Observable<AdministrationResultStatus>{
        return this.systemApiClient.editService(body);
    }

    removeService(serviceId: number | undefined): Observable<AdministrationResultStatus>{
        return this.systemApiClient.removeService(serviceId);
    }

    retrieveServiceById(serviceId: number | undefined): Observable<ServiceDataAdministrationResult>{
        return this.systemApiClient.retrieveServiceById(serviceId);
    }

}
